import React from "react";
import PropTypes from "prop-types";
import TableSectionContext from "./Table/TableSectionContext";

/** Represents a block of rows that consist of column headers for the table. */
import { jsx as _jsx } from "react/jsx-runtime";
export default function THead(_ref) {
  let {
    children,
    ...props
  } = _ref;
  return /*#__PURE__*/_jsx("thead", {
    ...props,
    children: /*#__PURE__*/_jsx(TableSectionContext.Provider, {
      value: "thead",
      children: children
    })
  });
}
THead.propTypes = {
  /** The table header rows. */
  children: PropTypes.node
};